import { DialogComponents } from '../index'
import Document from './document/Document.vue'
import DocumentSignature from './document/DocumentSignature.vue'
import Order from './Order.vue'
import UserPhoto from './user/photo/Index.vue'
import TemplateGroup from './templateGroup/Index.vue'
import User from './User.vue'
import UserCard from './UserCard.vue'
import Absence from './Absence.vue'
import RelatedOrder from './RelatedOrder.vue'
import ChangeUser from './ChangeUser.vue'
import TemplateRoutingDocument from './TemplateRoutingDocument.vue'
import Department from './Department.vue'
import ChangeDepartment from './ChangeDepartment.vue'
import FamiliarizationReport from './FamiliarizationReport.vue'
import SimpleDialog from './SimpleDialog.vue'
import Textarea from './Textarea.vue'
import Table from './Table.vue'
import DocumentAgreementUsers from './document/DocumentAgreementUsers.vue'
import DocumentAgreementHistory from './document/DocumentAgreementHistory.vue'
import FamiliarizationUsers from './FamiliarizationUsers.vue'
import Comments from './comments/Comments.vue'
import OrderDeactivate from './OrderDeactivate.vue'
import Contractor from './contractor/Contractor.vue'
import ContractorContact from './contractor/Contact.vue'
import Correspondence from './correspondence/Correspondence.vue'
import CorrespondenceDeliver from './correspondence/Deliver.vue'
import CorrespondenceDeliveryInfo from './correspondence/DeliveryInfo.vue'
import CorrespondenceTasks from './correspondence/Tasks.vue'
import RelatedCorrespondence from './correspondence/Related.vue'
import RelatedTask from './task/RelatedTask.vue'
import Notes from './notes/Notes.vue'
import ClientAccess from './client-access/ClientAccess.vue'
import SignDocument from './sign-document/SignDocument.vue'
import SignDiia from './sign-document/sign-cloud/SignDiia.vue'
import CopyTask from './task/CopyTask.vue'
import DocumentSendToSign from './document/DocumentSendToSign.vue'
import DocumentSendToReview from './document/DocumentSendToReview.vue'
import DocumentCancel from './document/DocumentCancel.vue'
import Audit from './audit/Audit.vue'
import AuditRecommendation from './audit/AuditRecommendation.vue'
import AuditRecommendationSetStatus from './audit/AuditRecommendationSetStatus.vue'
import AuditComplete from './audit/AuditComplete.vue'
import AuditFlaw from './audit/AuditFlaw.vue'
import AuditRisk from './audit/AuditRisk.vue'
import IncidentExecutor from './incident/IncidentExecutor.vue'
import IncidentIssue from './incident/IncidentIssue.vue'
import IncidentIssueTask from './incident/IncidentIssueTask.vue'
import IncidentRiskAssessment from './incident/IncidentRiskAssessment.vue'
import IncidentResolution from './incident/IncidentResolution.vue'
import IncidentSetStatus from './incident/IncidentSetStatus.vue'
import CreateTask from '@/dialog/components/task/CreateTask.vue'
import PerformerUsers from '@/dialog/components/correspondence/PerformerUsers.vue'
import SelectDepartmentPerson from '@/dialog/components/task/SelectDepartmentPerson.vue'
import TaskDelegation from '@/dialog/components/task/TaskDelegation.vue'
import ContractorDetails from '@/dialog/components/contractor/ContractorDetails.vue'
import TemplateSelect from '@/dialog/components/TemplateSelect.vue'
import SelectDocumentAgreement from '@/dialog/components/SelectDocumentAgreement.vue'
import UserSelect from '@/dialog/components/UserSelect.vue'
import Protocol from './protocol/Protocol.vue'
import RelatedProtocol from './protocol/RelatedProtocol.vue'
import ProtocolDeactivate from './protocol/ProtocolDeactivate.vue'
import Role from './Role.vue'
import RegistrationJournalDialog from './registration-journal/RegistrationJournal.vue'
import DocTypeClassDialog from './doc-type/DocTypeClass.vue'
import FieldDefinitionDialog from './doc-type/FieldDefinition.vue'
import DocTypeDefinitionDialog from './doc-type/DocTypeDefinition.vue'
import OrganizationDialog from './organization/Organization.vue'
import OrgDirectoryItem from './org-structure/OrgDirectoryItem.vue'
import InternalDepartmentDialog from './org-structure/InternalDepartment.vue'
import InternalStaffUnitDialog from './org-structure/InternalStaffUnit.vue'
import StaffUnitAssignmentDialog from './org-structure/StaffUnitAssignment.vue'
import Plan from './audit/Plan.vue'
import AuditAttach from './audit/AuditAttach.vue'
import DocTypeAccess from './doc-type/DocTypeAccess.vue'
import DocTypeField from './doc-type/DocTypeField.vue'
import DocTypeRoute from './doc-type/DocTypeRoute.vue'
import DocTypeRouteStage from './doc-type/DocTypeRouteStage.vue'
import MaskPlaceholder from './registration-journal/MaskPlaceholder.vue'
import Delegation from './user/delegation/Delegation.vue'
import DelegationCreate from './user/delegation/DelegationCreate.vue'
import DocumentAcceptance from './document/acceptance/DocumentAcceptance.vue'
import DelegationSettings from './user/delegation/DelegationSettings.vue'
import DelegationRestriction from './user/delegation/DelegationRestriction.vue'
import { getPersonName } from 'best-modules/utils/helpers'
import DocumentRelation from './document/DocumentRelation.vue'
import DocumentRevision from './document/DocumentRevision.vue'
import DocumentRegistration from './document/DocumentRegistration.vue'
import DocumentRouteSignatures from './document/DocumentRouteSignatures.vue'
import DocumentAcceptanceParticipants from './document/DocumentAcceptanceParticipants.vue'
import DocumentReturnFromReview from './document/DocumentReturnFromReview.vue'
import DocumentChangeReviewer from './document/DocumentChangeReviewer.vue'
import IncidentIssueSetStatus from '@/dialog/components/incident/IncidentIssueSetStatus.vue'

const invalidAction = () => {
  throw new Error('Invalid dialog action')
}
const getDefaultTitle = (action?: string | null): string => {
  switch (action) {
    case 'create':
      return 'Створити'
    case 'update':
      return 'Редагувати'
    case 'delete':
      return 'Видалити'
    default:
      return invalidAction()
  }
}

const components: DialogComponents = {
  DocumentReturnFromReview: {
    component: DocumentReturnFromReview,
    title() {
      return 'Повернути з доопрацювання'
    },
  },
  DocumentChangeReviewer: {
    component: DocumentChangeReviewer,
    title() {
      return 'Направити документ на розгляд'
    },
  },
  DocumentRouteSignatures: {
    component: DocumentRouteSignatures,
    width: 640,
    title() {
      return 'Електронні підписи'
    },
    subtitle() {
      return 'ЕЦП / КЕП накладені на документ'
    },
  },
  DocumentAcceptanceParticipants: {
    component: DocumentAcceptanceParticipants,
    width: 600,
    title() {
      return 'Учасники ознайомлення'
    },
  },
  SimpleDialog: {
    component: SimpleDialog,
    title() {
      return ''
    },
  },
  Document: {
    component: Document,
    width: '560px',
    title() {
      return 'Створення договору'
    },
    subtitle() {
      return 'Внесіть договір вручну до системи'
    },
  },
  DocumentSignature: {
    component: DocumentSignature,
    width: '750px',
    title({ action }) {
      return `${getDefaultTitle(action)} документ`
    },
  },
  DocumentSendToSign: {
    component: DocumentSendToSign,
    title() {
      return 'Відправка документа на підписання'
    },
  },
  DocumentSendToReview: {
    component: DocumentSendToReview,
    width: '520px',
    title() {
      return 'Передати на розгляд'
    },
    submitLabel: 'Відправити',
  },
  Order: {
    component: Order,
    title({ action }) {
      return `${getDefaultTitle(action)} наказ`
    },
  },
  UserPhoto: {
    component: UserPhoto,
    title() {
      return 'Змінити фото'
    },
  },
  TemplateGroup: {
    component: TemplateGroup,
    width: '760px',
    title() {
      return 'Налаштування маршрута'
    },
    subtitle({ dialogData }) {
      const document = dialogData?.document
      const template = dialogData?.template
      const name = document?.name || template?.name || dialogData?.name
      const typeName =
        document?.type?.name ||
        document?.documentType?.name ||
        template?.documentType?.name

      return [name, typeName].filter(Boolean).join(' · ')
    },
  },
  User: {
    component: User,
    width: '55rem',
    title() {
      return 'Новий співробітник'
    },
    subtitle() {
      return 'Заповніть основні дані для створення картки'
    },
  },
  UserCard: {
    component: UserCard,
    width: '1120px',
    title({ params, dialogData }) {
      return (
        params?.title ||
        dialogData?.title ||
        (dialogData?.mode === 'profile' ? 'Профіль' : 'Картка співробітника')
      )
    },
  },
  Absence: {
    component: Absence,
    title() {
      return 'Створити відпустку'
    },
  },
  RelatedOrder: {
    component: RelatedOrder,
    title() {
      return "Додати пов'язаний наказ"
    },
  },
  ChangeUser: {
    component: ChangeUser,
    title() {
      return 'Змінити користувача'
    },
  },
  TemplateRoutingDocument: {
    component: TemplateRoutingDocument,
    title() {
      return 'Створити шаблон'
    },
  },
  Department: {
    component: Department,
    title() {
      return 'Створити департамент'
    },
    width: 750,
  },
  ChangeDepartment: {
    component: ChangeDepartment,
    title() {
      return 'Змінити депаратамент'
    },
  },
  FamiliarizationReport: {
    component: FamiliarizationReport,
    title() {
      return 'Сформувати звіт'
    },
  },
  Textarea: {
    component: Textarea,
    title({ dialogData }) {
      const { dialogTitle = 'Введіть текст' } = dialogData
      return dialogTitle
    },
  },
  Table: {
    component: Table,
    title({ dialogData }) {
      const { dialogTitle = 'Список' } = dialogData
      return dialogTitle
    },
  },
  DocumentAgreementUsers: {
    component: DocumentAgreementUsers,
    title() {
      return 'Учасники погодження'
    },
    subtitle({ dialogData }) {
      return String(dialogData.name)
    },
  },
  DocumentAgreementHistory: {
    component: DocumentAgreementHistory,
    width: '600px',
    title() {
      return 'Історія погодження'
    },
    subtitle({ dialogData }) {
      return String(dialogData.name)
    },
  },
  FamiliarizationUsers: {
    component: FamiliarizationUsers,
    title() {
      return 'Учасники ознайомлення'
    },
    subtitle({ dialogData }) {
      return String(dialogData.name)
    },
  },
  Comments: {
    component: Comments,
    title() {
      return 'Коментарі'
    },
  },
  OrderDeactivate: {
    component: OrderDeactivate,
    title() {
      return 'Деактивація наказу'
    },
  },
  Contractor: {
    component: Contractor,
    title() {
      return 'Створити контрагента'
    },
  },
  ContractorContact: {
    component: ContractorContact,
    title({ action, dialogData }) {
      return `${getDefaultTitle(action)} ${dialogData.title}`
    },
  },
  ContractorDetails: {
    component: ContractorDetails,
    width: '1100px',
    title({ dialogData }) {
      return dialogData.title
    },
  },
  Correspondence: {
    component: Correspondence,
    title() {
      return 'Створити кореспонденцію'
    },
  },
  CorrespondenceDeliver: {
    component: CorrespondenceDeliver,
    title() {
      return 'Доставка кореспонденції'
    },
  },
  CorrespondenceDeliveryInfo: {
    component: CorrespondenceDeliveryInfo,
    title({ dialogData }) {
      return dialogData.title
    },
  },
  CorrespondenceTasks: {
    component: CorrespondenceTasks,
    width: '650px',
    title() {
      return 'Завдання'
    },
  },
  RelatedCorrespondence: {
    component: RelatedCorrespondence,
    title() {
      return "Пов'язана кореспонденція"
    },
  },
  PerformerUsers: {
    component: PerformerUsers,
    title({ dialogData }) {
      return dialogData.title
    },
  },
  CreateTask: {
    component: CreateTask,
    width: '620px',
    title() {
      return 'Нове завдання'
    },
    subtitle() {
      return "Заповніть обов'язкові поля для створення завдання"
    },
    submitLabel: 'Створити',
  },
  RelatedTask: {
    component: RelatedTask,
    title() {
      return "Пов'язані завдання"
    },
  },
  CopyTask: {
    component: CopyTask,
    title() {
      return 'Копіювання завдання'
    },
  },
  TaskDelegation: {
    component: TaskDelegation,
    title() {
      return 'Делегувати завдання'
    },
    submitLabel: 'Делегувати',
  },
  Notes: {
    component: Notes,
    title() {
      return 'Примітки'
    },
  },
  ClientAccess: {
    component: ClientAccess,
    title() {
      return 'Доступ до документа'
    },
  },
  SignDocument: {
    component: SignDocument,
    title() {
      return 'Підпис документа'
    },
    width: 520,
  },
  SignDiia: {
    component: SignDiia,
    title() {
      return 'Підписання у застосунку Дія'
    },
  },
  DocumentCancel: {
    component: DocumentCancel,
    title() {
      return 'Ануляція документа'
    },
  },
  Audit: {
    component: Audit,
    width: '560px',
    title() {
      return 'Аудит'
    },
  },
  AuditRecommendation: {
    component: AuditRecommendation,
    title({ action }) {
      return action === 'update'
        ? 'Редагувати рекомендацію'
        : 'Нова рекомендація'
    },
    width: '600px',
  },
  AuditRecommendationSetStatus: {
    component: AuditRecommendationSetStatus,
    title() {
      return 'Статус рекомендації'
    },
  },
  AuditComplete: {
    component: AuditComplete,
    title({ params }) {
      return params?.title
    },
    subtitle({ params }) {
      return params?.subtitle
    },
  },
  AuditFlaw: {
    component: AuditFlaw,
    title({ action }) {
      return action === 'update'
        ? 'Редагувати факт недоліку'
        : 'Новий факт недоліку'
    },
  },
  AuditRisk: {
    component: AuditRisk,
    title() {
      return 'Ризик факту недоліку'
    },
  },
  IncidentRiskAssessment: {
    component: IncidentRiskAssessment,
    width: '680px',
    title() {
      return 'Оцінка ризику'
    },
    subtitle() {
      return 'Заповніть суму збитків, можливі втрати та ймовірність реалізації'
    },
    submitLabel: 'Зберегти оцінку',
  },
  IncidentIssue: {
    component: IncidentIssue,
    width: '680px',
    title() {
      return 'Новий недолік'
    },
    subtitle() {
      return 'Опишіть недолік інциденту'
    },
  },
  IncidentIssueSetStatus: {
    component: IncidentIssueSetStatus,
    title() {
      return 'Зміна статусу'
    },
  },
  IncidentIssueTask: {
    component: IncidentIssueTask,
    width: '680px',
    title() {
      return 'Нове завдання щодо недоліку'
    },
    subtitle() {
      return 'Опишіть завдання, виконавця та дедлайн'
    },
    submitLabel: 'Створити завдання',
  },
  IncidentExecutor: {
    component: IncidentExecutor,
    width: '520px',
    title() {
      return 'Новий виконавець'
    },
    subtitle() {
      return 'Оберіть користувача, відповідального за роботи в межах інциденту'
    },
    submitLabel: 'Додати виконавця',
  },
  IncidentResolution: {
    component: IncidentResolution,
    width: '620px',
    title() {
      return 'Врегулювання інциденту'
    },
    subtitle() {
      return 'Зафіксуйте результати усунення інциденту та заходи для запобігання повтору'
    },
    submitLabel: 'Врегулювати інцидент',
  },
  IncidentSetStatus: {
    component: IncidentSetStatus,
    width: '520px',
    title({ dialogData }) {
      return dialogData.action.label
    },
  },
  SelectDepartmentPerson: {
    component: SelectDepartmentPerson,
    width: '550px',
    title() {
      return 'Оберіть користувача з департаменту'
    },
  },
  TemplateSelect: {
    component: TemplateSelect,
    title() {
      return 'Оберіть маршрут'
    },
  },
  SelectDocumentAgreement: {
    component: SelectDocumentAgreement,
    title() {
      return 'Оберіть документ'
    },
  },
  UserSelect: {
    component: UserSelect,
    title() {
      return 'Оберіть користувача'
    },
  },
  Protocol: {
    component: Protocol,
    title() {
      return 'Створити протокол'
    },
  },
  RelatedProtocol: {
    component: RelatedProtocol,
    title() {
      return 'Додати повʼязаний протокол'
    },
  },
  ProtocolDeactivate: {
    component: ProtocolDeactivate,
    title() {
      return 'Деактивувати протокол'
    },
  },
  Role: {
    component: Role,
    title({ action }) {
      return action === 'update' ? 'Редагування ролі' : 'Створення ролі'
    },
  },
  RegistrationJournal: {
    component: RegistrationJournalDialog,
    title({ params }) {
      return params?.title || 'Журнал реєстрацій'
    },
  },
  MaskPlaceholder: {
    component: MaskPlaceholder,
    title({ params }) {
      return params?.title
    },
    subtitle({ params }) {
      return params?.subtitle
    },
    width: '620px',
  },
  DocTypeClass: {
    component: DocTypeClassDialog,
    title({ params }) {
      return params?.title || 'Клас документа'
    },
  },
  FieldDefinition: {
    component: FieldDefinitionDialog,
    title({ params }) {
      return params?.title || 'Поле'
    },
    width: '550px',
  },
  DocTypeDefinition: {
    component: DocTypeDefinitionDialog,
    title({ params }) {
      return params?.title || 'Тип документа'
    },
  },
  Organization: {
    component: OrganizationDialog,
    title({ params }) {
      return params?.title || 'Організація'
    },
  },
  OrgDirectoryItem: {
    component: OrgDirectoryItem,
    title({ params }) {
      return params?.title || 'Довідник'
    },
  },
  InternalDepartment: {
    component: InternalDepartmentDialog,
    title({ params }) {
      return params?.title || 'Внутрішній підрозділ'
    },
    width: '600px',
  },
  InternalStaffUnit: {
    component: InternalStaffUnitDialog,
    title({ params }) {
      return params?.title || 'Штатна одиниця'
    },
    width: '600px',
  },
  StaffUnitAssignment: {
    component: StaffUnitAssignmentDialog,
    width: '550px',
    title({ params }) {
      return params?.title
    },
    subtitle({ params }) {
      return params?.subtitle
    },
  },
  Plan: {
    component: Plan,
    title({ action }) {
      return action === 'update' ? 'Редагувати план' : 'Новий план аудиту'
    },
  },
  AuditAttach: {
    component: AuditAttach,
    width: '460px',
    title() {
      return 'Додати аудит до плану'
    },
    subtitle() {
      return 'Оберіть один або декілька аудитів'
    },
  },
  DocTypeAccess: {
    component: DocTypeAccess,
    title() {
      return 'Додати доступ'
    },
  },
  DocTypeField: {
    component: DocTypeField,
    width: '620px',
    title({ action }) {
      return action === 'update' ? 'Редагувати поле' : 'Додати поле'
    },
    subtitle() {
      return 'Налаштуйте параметри поля картки документа'
    },
  },
  DocTypeRoute: {
    component: DocTypeRoute,
    width: '700px',
    title({ action }) {
      return `${getDefaultTitle(action)} маршрут`
    },
    subtitle() {
      return 'Вкажіть назву та режим маршруту погодження'
    },
  },
  DocTypeRouteStage: {
    component: DocTypeRouteStage,
    width: '650px',
    title({ action }) {
      return `${getDefaultTitle(action)} етап погодження`
    },
  },
  Delegation: {
    component: Delegation,
    width: '640px',
    title({ params }) {
      return params?.title
    },
    subtitle({ params }) {
      return params?.subtitle
    },
  },
  DelegationCreate: {
    component: DelegationCreate,
    width: '520px',
    title() {
      return "Новий об'єкт делегування"
    },
  },
  DocumentAcceptance: {
    component: DocumentAcceptance,
    width: '550px',
    title() {
      return 'Додати на ознайомлення'
    },
    subtitle() {
      return 'Виберіть людей з дерева підрозділів'
    },
  },
  DelegationSettings: {
    component: DelegationSettings,
    width: '860px',
    title({ dialogData }) {
      const delegateUser = dialogData?.delegation?.delegateUser
      if (!delegateUser) return 'Параметри делегування'
      return `Параметри делегування — ${getPersonName(delegateUser, {
        initials: true,
      })}`
    },
  },
  DelegationRestriction: {
    component: DelegationRestriction,
    width: '680px',
    title({ action }) {
      return action === 'update'
        ? 'Редагувати тип документа'
        : 'Додати тип документа'
    },
    subtitle({ action }) {
      return action === 'update' ? 'Редагування запису' : 'Новий запис'
    },
  },
  DocumentRelation: {
    component: DocumentRelation,
    width: '700px',
    title() {
      return 'Додати звʼязок'
    },
    subtitle() {
      return "Оберіть документ для створення двостороннього зв'язку"
    },
  },
  DocumentRevision: {
    component: DocumentRevision,
    title() {
      return 'Введіть коментар'
    },
  },
  DocumentRegistration: {
    component: DocumentRegistration,
    width: '640px',
    title() {
      return 'Реєстрація документа'
    },
    subtitle() {
      return 'Присвоєння реєстраційного номера'
    },
  },
}

export default components
